import { defineMessages } from 'react-intl';

export const switcherMessages = defineMessages({
  switcher: {
    defaultMessage: 'Switch to...',
    description: `Button to show the user products they have access and can switch into`,
    id: 'uchi.switcherbutton.label',
  },
});
